// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dialog":"dialog_+QjGQ","ui_mask":"ui_mask_CLIlB"};